<template>
    <div class="mask" v-if="showFlag">
      <div  class="msg-info border flex-col" @click="stopPropa" >
        <div class="flex flex-row flex-space-between padding-m">
            <div class="font-bold">通知中心</div>
            <div @click="moreClick"><img class="gengduo pointer" src="@/assets/images/gengduo.png"/></div>
        </div>
        <div class="msg-tool-bar border-radius-ms flex flex-row flex-space-evenly flex-center-cz">
            <div class=" flex flex-center-sp flex-center-cz pointer msg-tool-label font-bold font-s" :class="{'msg-tool-button': activeMsgMenu == 'hd'}" @click="hdClick">互动消息({{hdMsgData.length}})</div>
            <div class=" flex flex-center-sp flex-center-cz pointer msg-tool-label font-bold font-s" :class="{'msg-tool-button': activeMsgMenu == 'sx'}" @click="sxClick">私信消息({{sxMsgData.length}})</div>
            <div class=" flex flex-center-sp flex-center-cz pointer msg-tool-label font-bold font-s" :class="{'msg-tool-button': activeMsgMenu == 'xt'}" @click="xtClick">站内消息({{xtMsgData.length}})</div>
        </div>

        <vue-custom-scrollbar style="height: calc(100% - 50px);">
            <div v-if="activeMsgMenu == 'sx'" class="flex flex-col margin-top-s">
              <div v-for="item in sxMsgData" class="flex flex-row flex-start margin-top-s">
                  <div style="width:20px"><img class="xiaoxi1-ico" src="@/assets/images/shixin.png"/></div>
                  <div style="margin-top: 2px;margin-left: 18px;" class="font-s flex flex-col">
                    <div  style="width: 230px;" class="flex flex-row flex-space-between" >
                        <div class="font-bold">{{item.userName}}</div>
                        <div>{{item.date}}</div>
                    </div>
                    <div :class="{'color-rgb-05': item.isRead != 0,'color-black': item.isRead == 0 }" @click="read(item.id)">{{item.msg}}</div>
                  </div> 
              </div>
            </div>

            <div v-if="activeMsgMenu == 'xt'" class="flex flex-col margin-top-s">
              <div v-for="item in xtMsgData" class="flex flex-row flex-start margin-top-s">
                  <div style="width:20px"><img class="xiaoxi1-ico" src="@/assets/images/xiaoxi1.png"/></div>
                  <div class="color-rgb-07 font-s" style="margin-top: 2px;margin-left: 18px;">
                    <div :class="{'color-rgb-05': item.isRead != 0,'color-black': item.isRead == 0 }" @click="read(item.id)">{{item.msg}}</div>
                  <div class="color-rgb-05">{{item.date}}</div> 
                  </div>
              </div>
            </div>

            <div v-if="activeMsgMenu == 'hd'" class="flex flex-col margin-top-s">
              <div v-for="item in hdMsgData" class="flex flex-row flex-start margin-top-s">
                  <div style="width:20px"><img class="user-ico-c" :src="item.face"/></div>
                  <div style="margin-top: 2px;margin-left: 18px;" class="font-s flex flex-col">
                    <div  style="width: 230px;" class="flex flex-row flex-space-between" >
                        <div class="font-bold">{{item.userName}}</div>
                        <div>{{item.date}}</div>
                    </div>
                    <div :class="{'color-rgb-05': item.isRead != 0,'color-black': item.isRead == 0 }" @click="read(item.id)">{{item.msg}}</div>
                  </div>      
              </div>       
            </div> 

        </vue-custom-scrollbar>

        <div class="msg-info-sjx"></div>  

        <popup-menu ref="msgMenu" :menuData="msgMenuData"  @menuClick="msgMenuClick" >
        </popup-menu>
    </div>

    </div>
    

</template>


<script>


import PopupMenu from '@/components/popupMenu/PopupMenu' 
import {messageList,readMessage, allRead, delReadMsg} from '@/api/api.js';
import {getDateStr, getJsDateTime} from "@/utils/dateUtils.js"

export default {
    name: 'MsgInfo',
    components: {PopupMenu},
    props: {
        show: {default: false},
    },
    created() {
    },
    watch: {
      show(val) {
          this.showFlag = val
          this.showMsgInfo();
      }
    },
    data() {
        return {
            showFlag: false,
            msgData:[],
            activeMsgMenu: 'hd',
            sxMsgData:[
            ],
            xtMsgData:[
            ],
            hdMsgData:[
            ],      
            msgMenuData: [
                {id:'allread',name:'标记所有为已读'},
                {id:'delete',name:'删除所有已读消息'}
            ],

        }
    },

    methods: {
        showMsgInfo() {
          this.hdMsgData = [];
          this.xtMsgData = [];
          this.sxMsgData = [];
          messageList().then((res) => {
            console.log("msg_info========",res);
              if ((res.data.success == true) && (res.data.result != null)) {
                this.msgData = res.data.result;
                this.msgData.forEach(item => {
                  if (item.msgType == "1") {
                    this.hdMsgData.push(
                      {
                        id: item.id,
                        userName: item.fromUserName,
                        face: require("@/assets/images/user.png"),
                        msg: item.content,
                        fileId: item.fileId,
                        isRead: item.isRead,
                        date: getDateStr(item.msgDate)
                      }
                    );
                  } 
                  if (item.msgType == "2") {
                    this.sxMsgData.push(
                      {
                        id: item.id,
                        userName: item.fromUserName,
                        msg: item.content,
                        isRead: item.isRead,
                        date: getDateStr(item.msgDate)
                      }
                    );
                  } 
                  if (item.msgType == "3") {
                    this.xtMsgData.push(
                      {
                        id: item.id,
                        userName: item.fromUserName,
                        msg: item.content,
                        isRead: item.isRead,
                        date: getDateStr(item.msgDate)
                      }
                    );
                  }  

                });
              } 
          })
        },
        stopPropa(event) {
            event || (event = window.event);
            event.stopPropagation ? event.stopPropagation(): (event.cancelBubble = true);
        },
        hdClick(event) {
            this.stopPropa(event);
            this.activeMsgMenu = 'hd';
        },
        sxClick(event) {
            this.stopPropa(event);
            this.activeMsgMenu = 'sx';
        },
        xtClick(event) {
            this.stopPropa(event);
            this.activeMsgMenu = 'xt';
        },
        moreClick(event) {
            this.$refs.msgMenu.show(event);//调用子组件的show方法，用于显示弹出式菜单，引用组件时，需要 ref="child"
        },
        read(id) {
          console.log("id")
          readMessage(id).then((res) => {
              if (res.data.success == true) {
                  this.showMsgInfo();
                  this.$emit("change");
              }
          });
        },
        msgMenuClick(id) {
          console.log("id====",id);
          if (id == "allread") {
            allRead().then((res) => {
              if (res.data.success == true) {
                  this.showMsgInfo();
                  this.$emit("change");
              }
            });
          }

          if (id == "delete") {
            delReadMsg().then((res) => {
              if (res.data.success == true) {
                  this.showMsgInfo();
                  this.$emit("change");
              }
            });
            
          }
          this.$refs.msgMenu.closeMenu();//关闭

        }
    }
}
</script>


<style scoped>
  .msg-info {
    position: absolute;
    background-color: #fff;
    border-radius: 10px;
    top:50px;
    right: 60px;
    height: 500px;
    width: 285px;
    z-index: 999;
    display: flex;
    flex-direction: column;
    padding: 10px;
  }
  .msg-info-sjx {
    transform: rotate(45deg);
    top: -7px;
    right: 27px;
    width: 10px;
    height: 10px;
    position: absolute;
    border-left: 1px solid rgba(0, 0, 0, .2);
    border-top: 1px solid rgba(0, 0, 0, .2);
    z-index: 9999;
    background-color: #fff;
  }
  .msg-tool-bar {
    margin-top: 0px;
    background-color: #f5f5f5;
    width: 100%;
    height: 40px;
  }

  .msg-tool-button {
    border-radius: 5px;
    background-color: #fff;
    height: 30px;
    font-size: 14px;
  }
  
  .msg-tool-label {
    width: 88px;
  }
  .gengduo {
    width: 25px;
    height: 25px;
  }
  .gengduo:hover {
    border-radius: 5px;
    background: rgba(0, 0, 0, .1);
  }


  .user-ico-c {
    margin-left: 8px;
    width: 24px;
    height: 24px;
  }

  .xiaoxi1-ico {
    margin-top: 3px;
    margin-left: 8px;
    width: 22px;
    height: 22px;
  }
  
</style>


// WEBPACK FOOTER //
// src/modules/msgInfo/MsgInfo.vue